import React, { useEffect, useState } from 'react';
import { Box, Typography, Alert, AlertTitle, Button } from '@mui/material';
import { isRXDAvailable } from '../../utils/rxd-api';

interface IframeDomainGuardProps {
	children: React.ReactNode;
}

interface ValidationResult {
	isValid: boolean;
}

export const AccessGuard: React.FC<IframeDomainGuardProps> = ({ children }) => {
	const [validationResult, setValidationResult] = useState<ValidationResult | null>(null);
	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		// Add a small delay to ensure all window properties are available
		const timer = setTimeout(() => {
            const isLocal = process.env.REACT_APP_BASE_URL?.includes("local");
			const result = isLocal || isRXDAvailable();
			setValidationResult({ isValid: result });
			setIsLoading(false);
		}, 100);

		return () => clearTimeout(timer);
	}, []);

	if (isLoading) {
		return (
			<Box sx={{ 
				display: 'flex', 
				justifyContent: 'center', 
				alignItems: 'center', 
				minHeight: '200px',
				p: 3
			}}>
				<Typography>Validating access...</Typography>
			</Box>
		);
	}

	if (!validationResult?.isValid) {
		return (
			<Box sx={{ 
				display: 'flex', 
				justifyContent: 'center', 
				alignItems: 'center', 
				minHeight: '100vh',
				p: 3,
				backgroundColor: '#f5f5f5'
			}}>
				<Alert 
					severity="error" 
					sx={{ 
						maxWidth: '600px',
						width: '100%'
					}}
				>
					<AlertTitle>Access Restricted</AlertTitle>
				</Alert>
			</Box>
		);
	}

	// Access is valid, render children
	return <>{children}</>;
};
